import { render, staticRenderFns } from "./userAudit.vue?vue&type=template&id=2f3028f7&scoped=true"
import script from "./userAudit.vue?vue&type=script&lang=js"
export * from "./userAudit.vue?vue&type=script&lang=js"
import style0 from "./userAudit.vue?vue&type=style&index=0&id=2f3028f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3028f7",
  null
  
)

export default component.exports